import React from 'react'
import "./about.css"
import AboutData from './AboutData'
import AboutMe from "../../Assets/AboutMe1.jpeg"
import Resume from "../../Assets/Resume.pdf"

function About() {
    return (
        <section className='about section' id="aboutme">
            <h2 className='section_title'>About Me</h2>
            <span className='section_subtitle'>My introduction</span>
            <div className='about_container container'>
                <img src={AboutMe} className='about_img'></img>
                <div className="about_data">

                    <AboutData />

                    <div className='about_description'>
                        <p className="about_description_1">

                            Hi Everyone My name is Soubhik Ghosh. I am a Software Engineer and I
                            have been working for past 2 Years with NOKIA Solutions and Networks.
                            I enjoy utilizing logic and code to give shape to my new innovative ideas. Currently I am
                            working on ReactJs and making beautiful UI-UX designs and websites.</p>
                        <p className="about_description_2"></p>

                        <p className="about_description_3">Apart from that, I am an avid Finance enthusiast and also have a deep love for photography.</p>
                    </div>

                    <a download="" href={Resume} className='button button--flex cv_download'>
                        Download CV
                        <i class="uil uil-import"></i>

                    </a>
                </div>


            </div>
        </section>
    )
}

export default About